module.exports = __webpack_public_path__ + "img/shou_icon.f843bc30.png";